// Import Redux Types
import {
  DOWNLOAD_CURRENT_OFFERING,
  SUCCESS_DOWNLOAD_CURRENT_OFFERING,
  ERROR_DOWNLOAD_CURRENT_OFFERING
  // DOWNLOAD_OFFERINGS_DATA,
  // SUCCESS_DOWNLOAD_OFFERINGS_DATA,
  // ERROR_DOWNLOAD_OFFERINGS_DATA
} from '../types/index'
// Import Actions
import { setDataModalAction } from './modalAction'
import { setCurrentOfferingAction }  from './generalAction'
// Import Services
import { get } from './../services/api'



// Functions
export function downloadCurrentOfferingAction( id:number ){
  return async (dispatch:any) => {
    dispatch( downloadCurrentOffering() )
    try {
      const response:any = await get(`data-ofrendas/${id}`)
      const newData = {
        idOffering: id,
        name: response.honoredname,
        age: response.honoreddate,
        photo: response.image,
        dedicatedText: response.dedicatory,
        dedicatedBy: `${response.firstname} ${response.lastname}`
      }
      dispatch( setCurrentOfferingAction( newData ) )
      dispatch( setDataModalAction( 'offering', newData ) )
      dispatch( successDownloadCurrentOffering( newData ) )
    } catch (error) {
      dispatch( errorDownloadCurrentOffering() )
    }
  }
}
const downloadCurrentOffering = () => ({
  type: DOWNLOAD_CURRENT_OFFERING
})
const successDownloadCurrentOffering = ( data:any ) => ({
  type: SUCCESS_DOWNLOAD_CURRENT_OFFERING,
  payload: data
})
const errorDownloadCurrentOffering = () => ({
  type: ERROR_DOWNLOAD_CURRENT_OFFERING
})


// export function downloadDataOfferingsAction( start:number, end:number ) {
//   return async (dispatch:any) => {
//     dispatch( downloadDataOfferings() )
//     try {
//       // const response = await get('photos?_start=0&_limit=10')
//       const response = await get(`photos?_start${start}&_limit=${end}`)
//       dispatch( successDownloadDataOfferings( response ) )
//     } catch (error) {
//       dispatch( errorDownloadDataOfferings )
//     }
//   }
// }
// const downloadDataOfferings = () => ({
//   type: DOWNLOAD_OFFERINGS_DATA
// })
// const successDownloadDataOfferings = (data:any) => ({
//   type: SUCCESS_DOWNLOAD_OFFERINGS_DATA,
//   payload: data
// })
// const errorDownloadDataOfferings = () => ({
//   type: ERROR_DOWNLOAD_OFFERINGS_DATA
// })
